/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Analysis } from './Analysis';
import type { CallStatus } from './CallStatus';
import type { Dictionary_unknown_ } from './Dictionary_unknown_';
import type { SimpleTranscription } from './SimpleTranscription';
/**
 * Interface representing a call document
 */
export type CallDocument = {
    createdAt: string;
    updatedAt: string;
    metadata?: Dictionary_unknown_;
    tenantId: string;
    category?: string;
    status: CallStatus;
    providerId: string;
    providerName: string;
    analysisConfigId?: number;
    from: string;
    to: string;
    redirectedTo?: string | null;
    duration: number;
    direction: string;
    startTime: string;
    customData: Dictionary_unknown_;
    recordingUrl?: string | null;
    analysis?: Analysis;
    transcription?: SimpleTranscription;
    id: string;
    modelType: CallDocument.modelType;
    archivedAt?: string | null;
    eventSequence?: number;
    eventTimestamp?: string;
    funnelId?: string;
    funnelConversationId?: string;
    contactId?: string;
    sessionId?: string;
    userId?: string | null;
    teamId?: string | null;
};
export namespace CallDocument {
    export enum modelType {
        CALL = 'Call',
    }
}

